import { LoginButton } from "@/components/Buttons/LoginButton/LoginButton";

export const LoginNoCode: React.FC = () => (
    <section>
        <h1>Log In</h1>

        <p>What are you waiting for?</p>

        <LoginButton />
    </section>
);
